export default __webpack_public_path__ + "static/media/homescreen.62a79df2.png";